"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Day = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Gate = _interopRequireDefault(require("../Gate"));

var Day = function Day(_ref) {
  var date = _ref.date,
      selectedDate = _ref.selectedDate,
      dayInCurrentMonth = _ref.dayInCurrentMonth,
      DayComponent = _ref.DayComponent,
      renderCustomDayFunction = _ref.renderCustomDayFunction,
      dayButtonDataQaProp = _ref.dayButtonDataQaProp;
  var year = date.getFullYear();
  var month = date.getMonth();
  var day = date.getUTCDate();
  var dateValue = "".concat(year, "-").concat(month, "-").concat(day);
  var customDay = renderCustomDayFunction && renderCustomDayFunction(date, selectedDate, dayInCurrentMonth, DayComponent);

  var CustomDayComponent = /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: typeof renderCustomDayFunction !== 'undefined',
    alternate: DayComponent
  }, customDay);

  var CustomComponentProps = CustomDayComponent.props || DayComponent.props;
  var dataQa = dayButtonDataQaProp || "calendar-day-button-".concat(dateValue);
  return /*#__PURE__*/_react["default"].createElement(CustomDayComponent.type, (0, _extends2["default"])({
    "data-qa": dataQa
  }, DayComponent.props, CustomComponentProps));
};

exports.Day = Day;
var _default = Day;
exports["default"] = _default;